import React from 'react';
import PropTypes from 'prop-types';
import ImageBG from '../ImageBG';

const HeaderFooter = ({
    logo, copyright
}) => (
    <>
        <div id="header">
            <table width="100%">
                <tbody>
                    <tr>
                        <td valign="bottom" height="70">
                            <h2>Titles Transaction Report</h2>
                        </td>
                        <td align="right" valign="bottom" height="70">
                            <ImageBG
                                src={logo}
                                width={120}
                                height={40}
                                backgroundPosition="center right"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div id="footer">
            <table width="100%">
                <tbody>
                    <tr>
                        <td align="left" height="30" valign="middle">
                            Page <span id="pagenumber"/>
                        </td>
                        <td align="right" height="30" valign="middle">
                            TITLES TRANSACTION REPORT
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2">
                            <span style={{ fontSize: 8, color: '#666666' }}>{copyright}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </>);

HeaderFooter.propTypes = {
    logo: PropTypes.string,
    copyright: PropTypes.string,
};
export default HeaderFooter;